<template>
  <div>
    <GridVx
      ref="bookingRoomTable"
      :columns="columnDefs"
      :auto-select-first-row="false"
      :auto-size-cell="true"
      :context="context"
      :rows="rowsUpdate"
      :want-to-get-row-selected-event="true"
      @rowClicked="onSelectionChanged"
    >
    </GridVx>
  </div>
</template>
<script>
import {
  CellRenderCheckboxReadonly,
  CellRenderCurrencyInput,
  CellRenderDeleteIcon,
  CellRenderSelect,
  CellRenderSelectWithSearchTable,
  CellRenderEditIcon,
  CellRenderTextInput
} from '@/utils/cellRenders'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderEditIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderDeleteIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderTextInput,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelect,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelectWithSearchTable,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCurrencyInput
  },
  props: {
    recordRows: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      rows: [],
      context: null,
      columnDefs: [
        {
          headerName: 'Master',
          field: 'is_master',
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center'
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_type_name',
          valueGetter: params => {
            return params.data?.room_type_name
          }
        },
        {
          headerName: 'Phòng',
          field: 'room_num',
          valueFormatter: params => {
            return params.data?.room_num
          }
        },
        {
          headerName: 'Ngày đến',
          field: 'arrive_date_time',
          valueFormatter: params => {
            if (params.data?.arrive_date) {
              return this.$moment(params.data.arrive_date).format('DD-MM-Y')
            }
            return null
          }
        },
        {
          headerName: 'Ngày đi',
          field: 'depart_date_time',
          valueFormatter: params => {
            if (params.data?.depart_date) {
              return this.$moment(params.data.depart_date).format('DD-MM-Y')
            }
            return null
          }
        },
        {
          headerName: 'Tiền tệ',
          field: 'currency_code'
        },
        {
          headerName: 'Tỉ giá',
          field: 'exchange_rate'
        },
        {
          headerName: 'Người lớn',
          field: 'num_of_guest'
        },
        {
          headerName: 'Trẻ em',
          field: 'child_num'
        },
        {
          headerName: 'Trẻ em dưới 5',
          field: 'u5_child_num'
        }
      ]
    }
  },
  computed: {
    rowsUpdate() {
      // return this.recordRows.length
      return this.recordRows.filter(item => {
        if (item.status === undefined) return item
        else if (item.status !== 3) return item
      })
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  async mounted() {
    this.rows = this.recordRows.filter(item => {
      if (item.status === undefined) return item
      else if (item.status !== 3) return item
    })
  },
  methods: {
    onSelectionChanged(event) {
      this.$emit('recordSelected', event)
    },
    changeCheckbox(colName, params, value) {
      const field = params.colDef.field
      if (field === 'is_master') {
        this.$emit('updateMasterRoom', colName, params, value)
      }
      /*       const index = params.rowIndex
      this.reservationStore.daily_price[index][field] = value */
    },
    changeCurrencyInput(colName, params, value) {},
    SelectInputChange(colName, params, value) {}
  }
}
</script>
